import 'vanilla-cookieconsent/dist/cookieconsent.css';

import * as CookieConsent from "vanilla-cookieconsent";

const revision = 1789991676 // Timestamp

const cc = CookieConsent

window.cc = cc

const runCookieConsent = () => cc.run({
    mode: 'opt-in',
    revision,
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'middle center',
        }
    },

    disablePageInteraction: true,

    onChange: ({ cookie }) => {
        if (!CookieConsent.acceptedCategory('analytics')) {
            if (typeof _paq !== 'undefined') {
                _paq.push(['forgetCookieConsentGiven'])
            }
        }
    },

    onConsent: ({ cookie }) => {
        if (CookieConsent.acceptedCategory('analytics')) {
            if (typeof _paq !== 'undefined') {
                _paq.push(['setCookieConsentGiven']);
            }
        }
    },

    categories: {
        necessary: {
            services: {
                turnstile: {
                    label: 'Cloudflare Turnstile',
                },
            },
            enabled: true,
            readOnly: true,
        },
        marketing: {
            enabled: false,
            readOnly: false,
        },
        analytics: {
            services: {
                sentry: {
                    label: 'Sentry',
                    cookies: [
                        {
                            name: /^sentryReplaySession$/,
                        },
                        {
                            name: /^__sentry$/,
                        }
                    ]
                },
                matomo: {
                    label: 'Matomo',
                },
            },
            enabled: false,
            readOnly: false,
        },
        external: {
            services: {
                map: {
                    label: 'Mapbox',
                },
                youtube: {
                    label: 'YouTube',
                },
                vimeo: {
                    label: 'Vimeo',
                },
                matterport: {
                    label: 'Matterport',
                },
            },
            enabled: false,
            readOnly: false,
        }
    },
    language: {
        default: 'de',
        autoDetect: 'document',
        translations: {
            de: '/api/translations/c-consent/de.json',
        }
    }
})

if (document.readyState === 'complete') {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(runCookieConsent)
    } else {
        setTimeout(runCookieConsent, 500)
    }
} else {
    window.addEventListener('load', () => {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(runCookieConsent)
        } else {
            setTimeout(runCookieConsent, 500)
        }
    }, { once: true })
}
